import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Grid } from '@mui/material';

import HeaderOnline from './panels/onlineasistance/Header';
import HeaderHome from './panels/homerepair/Header';
import HeaderReview from './panels/reviewtuning/Header';
import OnlineDescription from './panels/onlineasistance/Description';
import ReviewDescription from './panels/reviewtuning/Description';
import HomeDescription from './panels/homerepair/Description';
import OnlineRequirements from './panels/onlineasistance/Requirements'
import ReviewRequirements from './panels/reviewtuning/Requirements';
import HomeRepairRequirements from './panels/homerepair/Requirements';
import LegalConditions from './panels/onlineasistance/LegalConditions';
import QuestionsOnline from './panels/onlineasistance/Ask';
import QuestionsReview from './panels/reviewtuning/Ask';
import QuestionsRepair from './panels/homerepair/Ask';
import { SERVICE_TYPES } from '../../../helper/types';

import '../../../assets/styles/Services.css';

export default function Options({ backToService, type }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [activeSection, setActiveSection] = useState(null);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    const sectionId = event.target.getAttribute('data-my-value');
    handleScrollToSection(sectionId);
  };

  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    switch (type) {
      case SERVICE_TYPES.ONLINE_ASSISTANCE:
        setActiveSection(SERVICE_TYPES.ONLINE_ASSISTANCE);
        break;
      case SERVICE_TYPES.HOME_REPAIR:
        setActiveSection(SERVICE_TYPES.HOME_REPAIR);
        break;
      case SERVICE_TYPES.REVIEW_TUNING:
        setActiveSection(SERVICE_TYPES.REVIEW_TUNING);
        break;
      default:
        setActiveSection(null);
    }
  }, [type]);

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        centered
        sx={{
          '.MuiTabs-indicator': {
            backgroundColor: 'red',
          },
          '.MuiTab-textColorPrimary': {
            color: 'black',
            '&.Mui-selected': { color: 'black' },
          },
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Tab label="Descripción" data-my-value="descripcion" />
        <Tab label="Requisitos del sistema" data-my-value="requisitos" />
        <Tab label="Condiciones Legales" data-my-value="condiciones" />
        <Tab label="Preguntas Frecuentes" data-my-value="preguntas" />
      </Tabs>
      <div className="servicios-container" style={{ marginTop: '30px', width: '100%' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} justifyContent="space-between">
            {activeSection == SERVICE_TYPES.ONLINE_ASSISTANCE && (
              <HeaderOnline
                backToService={backToService}
                setActiveSection={setActiveSection}
              />
            )}
            {activeSection == SERVICE_TYPES.HOME_REPAIR && (
              <HeaderHome setActiveSection={setActiveSection} />
            )}
            {activeSection == SERVICE_TYPES.REVIEW_TUNING && (
              <HeaderReview setActiveSection={setActiveSection} />
            )}
          </Grid>
        </Box>
      </div>
      <div id="descripcion" tabIndex="-1" style={{ padding: '50px', maxWidth: '950px', margin: 'auto', marginBottom: '30px' }}>
        <Typography variant="h5" component="h1" style={{textAlign: 'center', color: 'red', marginBottom: '30px'}}>Descripción</Typography>
        {activeSection == SERVICE_TYPES.ONLINE_ASSISTANCE && (<OnlineDescription />)}
        {activeSection == SERVICE_TYPES.REVIEW_TUNING && (<ReviewDescription />)}
        {activeSection == SERVICE_TYPES.HOME_REPAIR && (<HomeDescription />)}
      </div>
      <div style={{background: 'rgb(246, 246, 246)'}}>
        <div id="requisitos" tabIndex="-1" style={{ padding: '50px', maxWidth: '950px', margin: 'auto', marginBottom: '30px', background: 'rgb(246, 246, 246);' }}>
          <Typography variant="h5" component="h1" style={{textAlign: 'center', color: 'red'}}>Requisitos del sistema</Typography>
          {activeSection == SERVICE_TYPES.ONLINE_ASSISTANCE && (<OnlineRequirements />)}
          {activeSection == SERVICE_TYPES.REVIEW_TUNING && (<ReviewRequirements />)}
          {activeSection == SERVICE_TYPES.HOME_REPAIR && (<HomeRepairRequirements />)}

        </div>
      </div>
      <div id="condiciones" tabIndex="-1" style={{ padding: '50px', maxWidth: '950px', margin: 'auto', marginBottom: '30px' }}>
        <Typography variant="h5" component="h1" style={{textAlign: 'center', color: 'red', marginBottom: '20px'}}>Condiciones Legales</Typography>
        {activeSection == SERVICE_TYPES.ONLINE_ASSISTANCE && (<LegalConditions />)}
        {activeSection == SERVICE_TYPES.REVIEW_TUNING && (<LegalConditions />)}
        {activeSection == SERVICE_TYPES.HOME_REPAIR && (<LegalConditions />)}
        
      </div>
      <div style={{background: 'rgb(246, 246, 246)'}}>
        <div id="preguntas" tabIndex="-1" style={{ padding: '50px', maxWidth: '950px', marginRight: 'auto', marginLeft: 'auto' }}>
          <Typography variant="h5" component="h1" style={{textAlign: 'center', color: 'red'}}>Preguntas Frecuentes</Typography>
          {activeSection == SERVICE_TYPES.ONLINE_ASSISTANCE && (<QuestionsOnline />)}
          {activeSection == SERVICE_TYPES.REVIEW_TUNING && (<QuestionsReview />)}
          {activeSection == SERVICE_TYPES.HOME_REPAIR && (<QuestionsRepair />)}
        </div>
      </div>
    </Box>
  );
}